<template>
  <b-modal id="modal-import" size="xl" centered hide-footer title="Thêm mới theo danh sách nhóm khách hàng"
    @hidden="resetModal">
    <b-form>
      <b-overlay :show="loading">
        <b-container fluid class="UserPackage-list-page__body mb-6 mt-6">
          <!-- Khoa form va bang khi da day job di: doi tham so giua luc chay chi gay nham lan -->
          <b-overlay :show="isLocked" rounded="sm" opacity="0.5">
          <b-row>
            <b-col cols="6">
              <div class="card card-custom gutter-b w-100">
                <div class="card-body mt-0">
                  <b-row>
                    <b-col>
                      <basic-select label="Loại nhắc nhở" placeholder="Zalo" name="reminderMethod"
                        data-vv-As="Loại nhắc nhở" :options="filteredReminderMethodOptions" :required="true"
                        v-validate="'required'" :value.sync="reminderMethod" :state="validateState('reminderMethod')"
                        :invalidFeedback="errors.first('reminderMethod')" track-by="value" value-label="text"
                        @input="selected($event, 'reminderMethod', filteredReminderMethodOptions)" 
                        v-b-tooltip.top="'Notify Zalo sẽ không hiển thị nếu user chưa có nhóm'"
                      />
                    </b-col>

                    <b-col>
                      <basic-select label="Danh sách nhóm" placeholder="Chọn nhóm" name="groupCustomer"
                        data-vv-As="Danh sách nhóm" v-validate="'required'" :options="customerGroupOptions"
                        track-by="onboardGroup" value-label="onboardGroup" :value.sync="form.groupCustomer"
                        :state="validateState('groupCustomer')" :invalidFeedback="errors.first('groupCustomer')" />
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <basic-select label="Cấp độ" placeholder="Cấp độ" name="level" data-vv-As="Cấp độ"
                        v-validate="'required'" :options="levels" track-by="value" value-label="text"
                        :value.sync="form.level" :state="validateState('level')"
                        :invalidFeedback="errors.first('level')" @input="selected($event, 'level', levels)" />
                    </b-col>

                    <b-col>
                      <basic-select label="Gói dịch vụ" placeholder="--- Chọn gói dịch vụ ---" data-vv-As="Gói dịch vụ"
                        track-by="id" value-label="name" :options="packageData"
                        :value.sync="form.selectedservicePackage" name="servicePackage" v-validate="'required'"
                        :state="validateState('servicePackage')" :invalidFeedback="errors.first('servicePackage')"
                        @input="selected($event, 'selectedservicePackage', packageData)" />
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <basic-date-picker label="Ngày bắt đầu" placeholder="Ngày bắt đầu" name="startDate"
                        data-vv-As="Ngày bắt đầu" :required="true" v-validate="'required'" :value.sync="form.startDate"
                        :state="validateState('startDate')" :invalidFeedback="errors.first('startDate')"
                        format="DD/MM/YYYY" @input="clearValidation('startDate')" />
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>

            <b-col cols="6">
              <div class="card card-custom gutter-b w-100">
                <div class="card-body mt-0">
                  <template-table :column="column" :data="filteredCustomers" :paging="paging" :tableAction="false"
                    :selectAction="false" :searchAction="false">
                    <template v-slot:body="{ item }">
                      <td>
                        {{ item.name }}
                        <span
                          v-if="item.zaloGroupId === 'NO_ZALO_GROUP' || item.useZaloGroup === false"
                          class="badge-no-zalo"
                        >Không nhóm</span>
                      </td>
                      <td>{{ item.phoneNumber }}</td>
                      <td>
                        <action-dropdown :value="item" :show_delete="isDeletePermission" :show_copy="false" :show_edit="false"
                          :show_view="false" @delete="showPopupDeleteStatus(item.id)">
                        </action-dropdown>
                      </td>
                    </template>
                  </template-table>
                </div>
              </div>
            </b-col>
          </b-row>
          </b-overlay>


          <!-- Tiến độ job chạy nền, chỉ hiện sau khi đã đẩy vào hàng đợi -->
          <div v-if="jobIds.length" class="card card-custom gutter-b w-100 mt-3">
            <div class="card-body">
              <h6 class="mb-3 d-flex align-items-center">
                <b-spinner
                  v-if="!isJobFinished"
                  small
                  variant="success"
                  class="mr-2"
                ></b-spinner>
                <span v-if="isJobFinished" class="text-success mr-2">&#10003;</span>
                <span>
                  {{ isJobFinished ? 'Đã tạo xong' : 'Đang tạo' }}
                  {{ totalCustomers }} người dùng gói dịch vụ
                </span>
              </h6>

              <b-progress :max="progress ? progress.total || 1 : 1" height="1.2rem" show-value>
                <b-progress-bar
                  :value="progress ? progress.processed : 0"
                  :animated="!isJobFinished"
                  variant="success"
                />
              </b-progress>

              <!-- Lượt poll đầu chưa về thì progress còn null, phải nói rõ đang chờ -->
              <div v-if="!progress" class="mt-3 text-center text-muted">
                Đang khởi tạo, chờ tiến độ từ Hangfire...
              </div>

              <b-row v-if="progress" class="mt-3 text-center">
                <b-col>
                  <small class="text-muted d-block">Đã xử lý</small>
                  <span class="h5">{{ progress.processed }}/{{ progress.total }}</span>
                </b-col>
                <b-col>
                  <small class="text-muted d-block">Thành công</small>
                  <span class="h5 text-success">{{ progress.success }}</span>
                </b-col>
                <b-col>
                  <small class="text-muted d-block">Lỗi</small>
                  <span class="h5" :class="progress.failed ? 'text-danger' : ''">{{ progress.failed }}</span>
                </b-col>
              </b-row>

              <div v-if="progress && progress.failedRows && progress.failedRows.length" class="mt-3">
                <h6 class="mb-2">Các khách lỗi ({{ progress.failedRows.length }})</h6>
                <div style="max-height: 220px; overflow-y: auto">
                  <table class="table table-sm">
                    <thead>
                      <tr>
                        <th>Số điện thoại</th>
                        <th>Họ tên</th>
                        <th>Lý do</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, idx) in progress.failedRows" :key="idx">
                        <td>{{ row.phoneNumber }}</td>
                        <td>{{ row.name }}</td>
                        <td class="text-danger">{{ row.error }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <p class="text-muted mb-0 mt-3">
                Có thể đóng cửa sổ này, job vẫn chạy tiếp. Báo cáo sẽ gửi qua email khi xong.
              </p>
            </div>
          </div>

          <div class="w-100 d-flex align-items-center justify-content-end mt-3">

            <b-button variant="secondary" @click="$bvModal.hide('modal-import')">
              {{ jobIds.length ? 'Đóng' : 'Huỷ' }}
            </b-button>
              <b-button v-if="!jobIds.length" class="btn ml-2" href="#" tabindex="0" @click="resetAndReloadModalImport">
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/refresh-cw.svg" />
              </span>
              Đặt lại
            </b-button>
            <b-button v-if="!jobIds.length" type="button" variant="success" class="ml-2" @click="handleValidate" :disabled="loading">
              <b-spinner v-if="loading" small class="mr-2"></b-spinner>
              <span v-else class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/save.svg" />
              </span>
              {{ loading ? 'Đang xử lý...' : 'Tạo mới danh sách' }}
            </b-button>
          </div>
        </b-container>
      </b-overlay>
    </b-form>

    <!-- Accept modal -->
    <b-modal id="accept-modal" ref="accept-modal" title="Xác nhận thông tin" size="sd" :hide-header-close="true"
      :no-close-on-backdrop="true">
      <b-overlay>
        <div class="confirmation-container">
          <div class="main-question">
            <p class="question-text">Bạn có chắc muốn tạo theo danh sách này không?</p>
          </div>

          <div class="notices-section">
            <div class="notice-item">
              <div class="notice-icon warning">
                <i class="fas fa-exclamation-triangle"></i>
              </div>
              <div class="notice-content">
                <span class="notice-title">Lưu ý về thời gian:</span>
                <span class="notice-text">Ngày bắt đầu là ngày hôm nay thì các thông báo diễn ra trước thời gian này sẽ
                  không diễn ra.</span>
              </div>
            </div>

            <div class="notice-item">
              <div class="notice-icon info">
                <i class="fas fa-info-circle"></i>
              </div>
              <div class="notice-content">
                <span class="notice-title">Gợi ý:</span>
                <span class="notice-text">Nếu tạo số lượng lớn. Có thể tắt màn chờ, thực hiện thao tác khác và làm mới danh sách UserPackage sau
                  vài
                  phút.</span>
              </div>
            </div>
          </div>
        </div>
      </b-overlay>

      <template #modal-footer>
        <div class="w-100 d-flex align-items-center justify-content-end">
          <b-button class="btn btn-plain ml-2" href="#" @click.stop="handleCancel" tabindex="0">
            Thoát
          </b-button>
          <b-button class="btn btn-success ml-2" href="#" @click.stop="submit" tabindex="0" :disabled="loading">
            <b-spinner v-if="loading" small class="mr-2"></b-spinner>
            <span v-else class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Basic/save.svg" />
            </span>
            {{ loading ? 'Đang gửi...' : 'Xác nhận' }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </b-modal>
</template>

<script>
import { convertDateToTimestamp } from '@/core/mixins/index.js';

// Số bản ghi kéo về mỗi request khi nạp toàn bộ khách hàng.
// KHÁC với paging.pageSize (số dòng hiển thị trên bảng, mặc định 10).
// Trước đây dùng chung một số nên 500 khách hàng thành 51 request song song.
const FETCH_PAGE_SIZE = 500;

const JOB_POLL_INTERVAL = 3000;

export default {
  name: 'ModalImport',
  props: {
    packageData: {
      type: Array,
      default: () => [],
    },
  },
  beforeDestroy() {
    this.stopPolling();
  },
  data() {
    return {
      // Client-side paging state
      paging: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      column: [
        {
          key: 'name',
          label: 'Tên khách hàng',
          sortable: false,
          style: { width: '50%' },
        },
        {
          key: 'phoneNumber',
          label: 'Số điện thoại',
          sortable: false,
          style: { width: '45%' },
        },
        {
          key: 'actionDropdown',
          label: '',
          sortable: false,
          style: { width: '5%' },
        },
      ],
      levels: [
        { text: 'Level 0', value: 0 },
        { text: 'Level 1', value: 1 },
        { text: 'Level 2', value: 2 },
        { text: 'Level 3', value: 3 },
      ],
      reminderMethodOptions: [
        { value: 0, text: 'Thông báo qua nhóm Zalo' },
        { value: 1, text: 'Thông báo qua ứng dụng DIAB' },
        { value: 2, text: 'Đồng thời qua nhóm Zalo và ứng dụng DIAB' },
        { value: 3, text: 'Không gửi thông báo' },
      ],
      form: {
        groupCustomer: null,
        level: null,
        selectedservicePackage: null,
        startDate: null,
      },
      reminderMethod: null,
      loading: false,

      // Tạo chạy ngầm qua Hangfire: giữ jobIds để poll tiến độ
      jobIds: [],
      progress: null,
      pollTimer: null,

      // Data stores
      customerGroupOptions: [], // unique onboardGroup options for the select
      groupListCache: [], // all rows for the selected group (not sliced)
      // Id coach đã bấm xoá trong phiên mở modal này. Danh sách giờ kéo lại từ server
      // mỗi lần đổi nhóm, không nhớ thì đổi nhóm qua lại là dòng đã xoá hiện lại —
      // bản cũ xoá khỏi danh sách toàn bộ nên không bị.
      removedIds: [],
      filteredCustomers: [], // sliced rows for current page (what table shows)
    };
  },
  computed: {
    isJobFinished() {
      return !!(this.progress && this.progress.finished);
    },
    // Mỗi job hiện là một khách, nhưng lấy từ progress.total cho chắc nếu đổi PhonesPerJob
    totalCustomers() {
      return this.progress?.total || this.jobIds.length;
    },
    // Đã enqueue thì không cho sửa nữa: job đã mang tham số của lượt này đi rồi
    isLocked() {
      return this.loading || this.jobIds.length > 0;
    },
    searchParams() {
      // Chỗ đặt điều kiện lọc gửi lên server. Phân trang KHÔNG thuộc về đây:
      // _fetchGroupMembers tự quyết định kích thước trang.
      return {};
    },
    hasNoZaloUser() {
      return this.groupListCache.some(
        (el) => el.zaloGroupId === 'NO_ZALO_GROUP' || el.useZaloGroup === false,
      );
    },
    filteredReminderMethodOptions() {
      if (this.hasNoZaloUser) {
        return this.reminderMethodOptions.filter((o) => o.value === 1 || o.value === 3);
      }
      return this.reminderMethodOptions;
    },
  },
  watch: {
    'form.groupCustomer'(newVal) {
      this.onGroupChanged(newVal);
    },
    hasNoZaloUser(val) {
      if (val) {
        const currentValue = this.reminderMethod?.value ?? this.reminderMethod;
        if (currentValue === 0 || currentValue === 2) {
          this.reminderMethod = this.reminderMethodOptions.find((o) => o.value === 1);
        }
      }
    },
    'paging.page'() {
      this.applyClientPagingFromCache();
    },
    'paging.pageSize'() {
      // Reset về trang 1 khi đổi pageSize cho UX ổn định
      this.paging.page = 1;
      this.applyClientPagingFromCache();
    },
  },
  methods: {
    // ===== Helpers =====
    clearValidation(fieldName) {
      if (this.form[fieldName]) {
        this.$validator.reset({ name: fieldName });
        this.$validator.errors.remove(fieldName);
        this.$validator.validate(fieldName);
      }
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref);
      }
      return null;
    },
    selected(value, formProperty, optionsArr) {
      this.form[formProperty] = optionsArr.find((el) => el.id === value || el.value === value) || null;
    },

    // ===== Lấy khách của MỘT nhóm, lọc ở server =====
    //
    // Bản cũ kéo TOÀN BỘ customer_receives (bắn song song mọi trang 500 dòng) chỉ để
    // gồm ra danh sách nhóm ở client, rồi vứt bỏ phần lớn ngay tại FE. Mỗi request đó
    // còn kéo theo 4 lượt enrich bên BE — một lần mở modal mất cả phút.
    //
    // Giờ: dropdown nhóm lấy từ endpoint distinct riêng, còn danh sách khách chỉ kéo
    // đúng nhóm đang chọn. Dùng status=1 (số ít) chứ KHÔNG dùng statuses=[1]: bên BE,
    // statuses có giá trị sẽ kích hoạt backfill cờ ghi DB ngay trong lượt đọc này.
    async _fetchGroupMembers(onboardGroup) {
      if (!onboardGroup) return [];

      const params = { onboardGroup, status: 1 };

      const first = await this.$api.get('CustomerReceives', {
        params: { ...params, page: 1, size: FETCH_PAGE_SIZE },
      });
      const firstData = first.data || [];
      const total = Number(first.meta?.total || firstData.length);
      const totalPages = Math.ceil(total / FETCH_PAGE_SIZE);

      const reqs = [];
      for (let p = 2; p <= totalPages; p += 1) {
        reqs.push(this.$api.get('CustomerReceives', {
          params: { ...params, page: p, size: FETCH_PAGE_SIZE },
        }));
      }
      const restRes = reqs.length ? await Promise.all(reqs) : [];
      const all = [...firstData, ...restRes.flatMap((r) => r.data || [])];

      // BE lọc onboardGroup bằng Contains nên "K1" còn kéo theo "K10" — với màn tạo gói
      // hàng loạt thì lấy dư một nhóm là tạo gói cho nhầm người. Chốt lại bằng so khớp đúng.
      return this._filterActiveWithGroup(all)
        .filter((el) => String(el.onboardGroup) === String(onboardGroup))
        .filter((el) => !this.removedIds.includes(el.id));
    },

    _filterActiveWithGroup(list) {
      return (list || []).filter((el) => el.status == 1 && el.onboardGroup != null);
    },

    applyClientPagingFromCache() {
      const page = Number(this.paging.page || 1);
      const size = Number(this.paging.pageSize || 10);
      const start = (page - 1) * size;
      const end = start + size;
      this.filteredCustomers = this.groupListCache.slice(start, end);
      this.paging.total = this.groupListCache.length;
    },

    onGroupChanged(groupId) {
      // Khi đổi nhóm, reset trang về 1 và recalc cache
      this.paging.page = 1;
      if (!groupId) {
        this.groupListCache = [];
        this.filteredCustomers = [];
        this.paging.total = 0;
        return;
      }
      this.loadGroupMembers(groupId);
    },

    // ===== UI actions =====
    async showPopupDeleteStatus(id) {
      const ok = await this.$swal({
        title: 'Xác nhận',
        text: `Bạn có chắc chắn muốn xóa người dùng khỏi danh sách không ?`,
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Huỷ bỏ',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Xác nhận',
            value: true,
            visible: true,
            className: '',
            closeModal: true,
          },
        },
      });
      if (ok) {
        // Không đụng DB — chỉ bỏ trong phiên này, mở lại modal là có lại
        this.removedIds.push(id);
        this.groupListCache = this.groupListCache.filter((el) => el.id !== id);
        this.applyClientPagingFromCache();

      }
    },

    resetModal() {
      this.form = {
        groupCustomer: null,
        level: null,
        selectedservicePackage: null,
        startDate: null,
      };
      this.reminderMethod = null;
      // Dừng poll khi đóng modal, nếu không timer chạy mãi sau khi component ẩn
      this.stopPolling();
      this.jobIds = [];
      this.progress = null;
      this.$validator.reset();
      this.$validator.errors.clear();
      this.paging.page = 1;
      this.paging.pageSize = 10;
      this.paging.total = 0;
    },

    async handleValidate() {
      const isValid = await this.$validator.validateAll();
      if (!isValid) return;

      // Lấy danh sách SĐT của TOÀN BỘ NHÓM đang chọn (không chỉ trang hiện tại)
      const phoneNumbers = this.groupListCache
        .map((el) => (el.phoneNumber || '').trim())
        .filter((x) => x);

      if (phoneNumbers.length > 0) {
        this.$bvModal.show('accept-modal');
      } else {
        this.$toastr.e({ title: 'Lỗi!', msg: 'Danh sách rỗng !' });
      }
    },

    async handleCancel() {
      this.$bvModal.hide('accept-modal');
    },

    async submit() {
      try {
        this.loading = true;

        // Thu thập SĐT của TOÀN BỘ NHÓM đang chọn
        const phoneNumbers = this.groupListCache
          .map((el) => (el.phoneNumber || '').trim())
          .filter((x) => x);

        const sp = this.form.selectedservicePackage;
        const payload = {
          phoneNumbers,
          servicePackageId: sp ? (typeof sp === 'object' ? sp.id : sp) : null,
          level: this.form.level
            ? typeof this.form.level === 'object'
              ? this.form.level.value
              : this.form.level
            : 0,
          startDate: this.form.startDate
            ? convertDateToTimestamp(this.form.startDate)
            : null,
          reminderMethod: this.reminderMethod ?? null,
          onboardGroup: this.form.groupCustomer || null,
        };

        const { meta, data, error } = await this.$api.post(
          'UserPackage/list/enqueue',
          payload,
        );

        if (!meta.success) {
          return this.$toastr.e({
            title: 'Lỗi!',
            msg: error?.message || 'Không đẩy được vào hàng đợi.',
          });
        }

        this.jobIds = data?.jobIds || [];
        this.progress = null;
        this.$bvModal.hide('accept-modal');

        this.$toastr.s({
          title: 'Đã tiếp nhận!',
          msg: `Đang tạo ${phoneNumbers.length} người dùng gói dịch vụ, chạy nền.`,
        });

        this.startPolling();
      } catch (e) {
        this.$toastr.e({ title: 'Lỗi!', msg: e?.message || 'Không tạo được danh sách.' });
      } finally {
        this.loading = false;
      }
    },

    startPolling() {
      this.stopPolling();
      if (!this.jobIds.length) return;

      this.pollTimer = setInterval(this.pollProgress, JOB_POLL_INTERVAL);
      this.pollProgress();
    },

    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },

    async pollProgress() {
      try {
        const { meta, data } = await this.$api.post(
          'UserPackage/list/jobs-progress',
          this.jobIds,
        );
        if (!meta.success || !data) return;

        this.progress = data;

        // Chốt thêm bằng số liệu: nếu đã xử lý đủ thì dừng, không chờ cờ finished.
        // Job bị Hangfire xoá sớm có thể làm cờ đó không bao giờ bật.
        const doneByCount = data.total > 0 && data.processed >= data.total;

        if (data.finished || doneByCount) {
          this.stopPolling();
          this.$toastr.s({
            title: 'Hoàn tất!',
            msg: `${data.success} khách thành công, ${data.failed} lỗi. Báo cáo đã gửi qua email.`,
          });
          this.reloadList();
        }
      } catch (e) {
        // Poll mỗi 3 giây, lỗi mạng tạm thời không cần báo cho user
      }
    },

    resetData() {
      this.paging.page = 1;
      this.paging.pageSize = 10;
    },

    // Mở modal chỉ nạp danh sách nhóm — một truy vấn DISTINCT trả vài chục chuỗi,
    // không đụng tới bảng khách. Danh sách khách đợi chọn nhóm xong mới kéo.
    async loadDataCustomerReceives() {
      try {
        this.loading = true;

        const res = await this.$api.get('CustomerReceives/OnboardGroups', {
          params: { status: 1 },
        });
        const groups = res.data || [];

        this.customerGroupOptions = groups.map((g) => ({ onboardGroup: g }));

        if (this.form.groupCustomer) {
          await this.loadGroupMembers(this.form.groupCustomer);
        } else {
          this.groupListCache = [];
          this.applyClientPagingFromCache();
        }
      } catch (error) {
        this.$toastr.e({ title: 'Lỗi', msg: error });
      } finally {
        this.loading = false;
      }
    },

    async loadGroupMembers(groupId) {
      if (!groupId) {
        this.groupListCache = [];
        this.applyClientPagingFromCache();
        return;
      }

      try {
        this.loading = true;
        this.groupListCache = await this._fetchGroupMembers(groupId);
        this.paging.page = 1;
        this.applyClientPagingFromCache();
      } catch (error) {
        this.$toastr.e({ title: 'Lỗi', msg: error });
      } finally {
        this.loading = false;
      }
    },

    async resetAndReloadModalImport() {
      try {
        this.loading = true;


        this.form = {
          groupCustomer: null,
          level: null,
          selectedservicePackage: null,
          startDate: null,
        };
        this.reminderMethod = null;


        if (this.$validator) {
          this.$validator.reset();
          if (this.$validator.errors) this.$validator.errors.clear();
        }


        this.paging.page = 1;
        this.paging.pageSize = 10;
        this.paging.total = 0;


        this.filteredCustomers = [];
        this.groupListCache = [];
        this.customerList = [];
        this.removedIds = [];


        await this.loadDataCustomerReceives();
      } catch (err) {
        if (this.$toastr) {
          this.$toastr.e({ title: 'Lỗi', msg: err });
        }
      } finally {
        this.loading = false;
      }
    },

    reloadList() {
      this.$emit('reload-data');
    },


  },
  created() {
    // Luôn load FULL LIST khi mở modal
    this.loadDataCustomerReceives();
  },
};
</script>

<style scoped>
.badge-no-zalo {
  display: inline-flex;
  align-items: center;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 1px 5px;
  border-radius: 3px;
  background: rgba(139, 92, 246, 0.12);
  color: #7c3aed;
  border: 1px solid rgba(139, 92, 246, 0.3);
  vertical-align: middle;
  margin-left: 4px;
  white-space: nowrap;
}

.confirmation-container {
  background: white;
  border-radius: 15px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  max-width: 550px;
  margin: 0 auto;
  padding: 0;
  overflow: hidden;
}

.confirmation-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 25px;
  text-align: center;
  position: relative;
}

.header-icon {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 15px;
  backdrop-filter: blur(10px);
}

.header-icon i {
  font-size: 22px;
  color: white;
}

.confirmation-title {
  margin: 0;
  font-weight: 600;
  font-size: 18px;
  color: white;
}

.main-question {
  padding: 25px 25px 20px;
  text-align: center;
}

.question-text {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.notices-section {
  padding: 0 25px 25px;
}

.notice-item {
  display: flex;
  align-items: flex-start;
  padding: 15px;
  margin-bottom: 12px;
  border-radius: 10px;
  border-left: 4px solid transparent;
  transition: all 0.3s ease;
}

.notice-item:last-child {
  margin-bottom: 0;
}

.notice-item:first-child {
  background: rgba(255, 193, 7, 0.08);
  border-left-color: #ffc107;
}

.notice-item:last-child {
  background: rgba(23, 162, 184, 0.08);
  border-left-color: #17a2b8;
}

.notice-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  flex-shrink: 0;
}

.notice-icon.warning {
  background: rgba(255, 193, 7, 0.15);
  color: #e0a800;
}

.notice-icon.info {
  background: rgba(23, 162, 184, 0.15);
  color: #138496;
}

.notice-icon i {
  font-size: 16px;
}

.notice-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.notice-title {
  font-weight: 600;
  color: #333;
  font-size: 14px;
  display: block;
}

.notice-text {
  color: #666;
  font-size: 13px;
  line-height: 1.5;
  display: block;
}

/* Hover effects */
.notice-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
}

/* Animation */
.confirmation-container {
  animation: slideInScale 0.4s ease-out;
}

@keyframes slideInScale {
  0% {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }

  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Responsive */
@media (max-width: 576px) {
  .confirmation-container {
    margin: 0 15px;
    max-width: none;
  }

  .confirmation-header,
  .main-question,
  .notices-section {
    padding-left: 20px;
    padding-right: 20px;
  }

  .notice-item {
    padding: 12px;
  }
}
</style>
